let promise;
export const loadClassPage = () =>
  (promise ||= import("../pages/seo/KlassforsaljningPage.jsx"));
